var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCornerRadius = function SvgCornerRadius(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.85,
    d: "M1 12.75C1 6.26065 6.26065 1 12.75 1C13.1642 1 13.5 1.33579 13.5 1.75C13.5 2.16421 13.1642 2.5 12.75 2.5C7.08908 2.5 2.5 7.08908 2.5 12.75C2.5 13.1642 2.16421 13.5 1.75 13.5C1.33579 13.5 1 13.1642 1 12.75Z"
  })));
};
export default SvgCornerRadius;